/**
 * メディアクエリ関連
 */

import { trigger } from './utility';

class MediaQueries {
	constructor(
		options = {
			tab: 800,
			sp: 640,
			customEvent: { elem: window, name: 'layoutChange' }
		}
	) {
		this.layout = '';
		this.options = {
			tab: options.tab,
			sp: options.sp,
			customEvent: options.customEvent
		};
		this.mql = {
			pc: window.matchMedia(`(min-width: ${this.options.tab + 1}px)`),
			tab: window.matchMedia(`(min-width: ${this.options.sp + 1}px) and (max-width: ${this.options.tab}px)`),
			sp: window.matchMedia(`(max-width: ${this.options.sp}px)`)
		};

		this.addListeners();

		// 初期レイアウト
		this.layout = this.mql.sp.matches ? 'sp' : this.mql.tab.matches ? 'tab' : 'pc';
	}

	/**
	 * イベント登録
	 */
	addListeners() {
		this.mql.pc.addListener(this.layoutChange.bind(this));
		this.mql.tab.addListener(this.layoutChange.bind(this));
		this.mql.sp.addListener(this.layoutChange.bind(this));
	}

	/**
	 * レイアウト変更
	 */
	layoutChange(e) {
		const media = e.media;

		if (media === this.mql.sp.media && e.matches) {
			this.layout = 'sp';
		} else if (media === this.mql.tab.media && e.matches) {
			this.layout = 'tab';
		} else if (media === this.mql.pc.media && e.matches) {
			this.layout = 'pc';
		}

		// レイアウト変更のカスタムイベント発火
		trigger(this.options.customEvent.elem, this.options.customEvent.name, {
			layout: this.layout
		});
	}

	/**
	 * レイアウト取得
	 */
	getLayout() {
		return this.layout;
	}
}

export default MediaQueries;



// WEBPACK FOOTER //
// ./src/js/module/Mediaqueries.js